import {
  CONTENT_KINERJA_UTAMA,
  CONTENT_PERILAKU_KERJA,
  SKP_DATA,
} from 'app/KinerjaKSPage/utils/demo/data'

import type { ResponseContentPerilakuKerja } from 'types/kinerja'
import type {
  ResponseKinerjaKs,
  ResponseContentKinerjaKSUtama,
  UpsertSKPKSPayload,
} from 'types/kinerja-ks'

const DEMO_SKP_PERENCANAAN_KEY = 'ks-skp-perencanaan-demo'

const initData = {
  skpData: SKP_DATA,
  contentKinerjaUtama: CONTENT_KINERJA_UTAMA,
  contentPerilakuKerja: CONTENT_PERILAKU_KERJA,
}

type DemoData = typeof initData
type Key = keyof DemoData

const initilaizeData = () => {
  // check if DEMO_SKP_PERENCANAAN_KEY is set in localStorage
  // if not, set it and return the value.

  if (localStorage.getItem(DEMO_SKP_PERENCANAAN_KEY) === null) {
    localStorage.setItem(DEMO_SKP_PERENCANAAN_KEY, JSON.stringify(initData))
  }
}

export const getDemoData = (key: Key) => {
  initilaizeData()

  const data = JSON.parse(
    localStorage.getItem(DEMO_SKP_PERENCANAAN_KEY)
  ) as DemoData

  return data[key]
}

const saveDemoData = (key: Key, value: DemoData[Key]) => {
  initilaizeData()

  const data = JSON.parse(localStorage.getItem(DEMO_SKP_PERENCANAAN_KEY))

  data[key] = value

  localStorage.setItem(DEMO_SKP_PERENCANAAN_KEY, JSON.stringify(data))
}

export const getSKPPerencanaan = () => {
  return getDemoData('skpData') as ResponseKinerjaKs
}

export const getContentKinerjaUtama = () => {
  return getDemoData('contentKinerjaUtama') as ResponseContentKinerjaKSUtama
}

export const getContentPerilakuKerja = () => {
  return getDemoData('contentPerilakuKerja') as ResponseContentPerilakuKerja
}

export const updateDemoSKP = async (data: UpsertSKPKSPayload) => {
  const skpData = getSKPPerencanaan()

  if (data.kepemimpinanSatuanPendidikan) {
    skpData.data.kepemimpinanSatuanPendidikan =
      data.kepemimpinanSatuanPendidikan
  }

  if (data.pengembanganKompetensi) {
    skpData.data.pengembanganKompetensi = data.pengembanganKompetensi
  }

  if (data.perilakuKerja) {
    skpData.data.perilakuKerja = data.perilakuKerja
  }

  saveDemoData('skpData', skpData)
}

export const updateSKPState = async () => {
  const skpData = getSKPPerencanaan()

  skpData.data.status = 'WAITING_APPROVAL'

  saveDemoData('skpData', skpData)
}
